<template>
    <div class="PersonCenter">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>GOEASY <span>PERSONAL CENTER</span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
      <!-- 实名认证窗口 -->
        <div class="AddInvoice flex" v-if="namerzstate">
        <div class="AddWrap">
          <header class="flexa">
            <i @click="CloseNameRz"><img src="../../assets/returns.png"/></i>
            <p>实名认证</p>
          </header>
          <div class="DeveloperWrap">
            <div class="EditList">
              <div class="List flexa"><span>真实姓名</span><input v-model="cardname" placeholder="上传身份证照片后自动获取"></div>
            </div>
            <div class="EditList">
              <div class="List flexa"><span>身份证号</span><input v-model="cardid" placeholder="上传身份证照片后自动获取"></div>
            </div>
            <div class="EditList">
              <div class="List flexa"><span>联系电话</span><input v-model="phone" placeholder="请输入联系电话"></div>
            </div>
            <div class="PicUp">
              <p style="font-size: 0.051rem;color: #414141;margin: 0.1rem 0 0.05rem">身份证人像面</p>
              <div class="HeaderPic">
                <i class="flex"><img src="../../assets/Buttonicon/camera.png"></i>
                <div class="Upload flex"><van-uploader :after-read="afterReadCardFront" /></div>
                <img class="headpic" v-if="carduppicfront!=''"  :src="carduppicfront">
              </div>
            </div>
            <div class="PicUp">
              <p style="font-size: 0.051rem;color: #414141;margin: 0.05rem 0">身份证国徽面</p>
              <div class="HeaderPic">
                <i class="flex flex"><img src="../../assets/Buttonicon/camera.png"></i>
                <div class="Upload flex"><van-uploader :after-read="afterReadCardBack" /></div>
                <img class="headpic" v-if="carduppicback!=''"  :src="carduppicback">
              </div>
            </div>
          </div>
          <div class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="PostRzData" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">提交</div></div>
        </div>
      </div>
      <!-- 企业注册窗口 -->
        <div class="AddInvoice flex" v-if="rzstate">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="Closerz"><img src="../../assets/returns.png"/></i>
                    <p>注册企业</p>
                </header>
                <div class="DeveloperWrap">
                    <ul v-if="rzaddstate && zcdata.length>0">
                        <li  v-for="(item, index) in zcdata" :key="index">
                            <p>{{ item.名称 }}</p>
                            <p>社会信用代码</p>
                            <p>{{ item.社会信用代码 }}</p>
                        </li>
                    </ul>
                    <div v-else>
                        <div class="InputWrap">
                            <div class="flexa">
              <span>企业名称</span
              ><input style="user-select: auto" v-model="zcuser" />
                            </div>
                            <div class="flexa">
              <span>社会信用代码</span
              ><input style="user-select: auto" v-model="zccode" />
                            </div>
                            <div class="flexa">
              <span>法人姓名</span
              ><input style="user-select: auto" v-model="zcname" />
                            </div>
                          <div class="flexa">
              <span>法人身份证号</span
              ><input style="user-select: auto" v-model="zccardid" />
                          </div>
<!--                            <div class="flexbetween">
              <span class="flex">邮箱</span
              ><input style="user-select: auto" v-model="zcemail" />
                            </div>-->
                            <div class="flexa">
              <span>联系人</span
              ><input style="user-select: auto" v-model="zccn" />
                            </div>
                            <div class="flexa">
              <span>联系方式</span
              ><input style="user-select: auto" v-model="zcphone" />
                            </div>
                          <div class="PicUp" style="width: 1.93rem;height: 1.2rem">
                            <p style="font-size: 0.051rem;color: #414141;margin: 0.05rem 0">上传营业执照</p>
                            <div class="HeaderPic" style="width: 1.93rem;height: 1.2rem">
                              <i class="flex"><img src="../../assets/Buttonicon/camera.png"></i>
                              <div class="Upload flex"><van-uploader :after-read="afterReadyingyepic" /></div>
                              <img class="headpic" v-if="yingyepic!=''"  :src="yingyepic">
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div v-if="rzaddstate && zcdata.length>0" class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="Add" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">新增</div></div>
                <div v-else class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="CheckComponey" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">提交</div></div>
            </div>
        </div>
        <!-- 充值入口 -->
        <div class="SaveMoneyWrap" v-if="MoneyOpenState">
            <Savemoney @closeWindow="closeWindow"></Savemoney>
        </div>
        <!-- 个人资料卡片 -->

        <div class="PersonCard">
           <div class="flexj Left">
               <div class="Head"><img src="../../assets/Buttonicon/head.jpg"></div>
               <div class="InputWrap">
                 <div class="Text flexa"><img src="../../assets/Buttonicon/p-1.png"><p>{{LoginUserInfo.goeasyid}}</p></div>
                 <div class="Text flexa"><img src="../../assets/Buttonicon/p2.png"><p>{{LoginUserInfo.username}}</p></div>
                 <div class="Text flexa"><img src="../../assets/Buttonicon/p-3.png"><p>{{LoginUserInfo.tel}}</p></div>
                 <div class="Text flexa" v-if="!Isrz"  style="position: relative"><img src="../../assets/p_rz.png"><p>未实名认证</p><p style="position: absolute;right: 0.08rem;font-size: 0.049rem;cursor: pointer;color: #fdca57" @click="ToNameRz">去认证 ></p></div>
                 <div class="Text flexa" v-else  style="position: relative"><img src="../../assets/p_rz.png"><p>实名认证已通过</p></div>
                <!-- <div class="Text flexa"><img src="../../assets/Buttonicon/p-4.png"><p>{{LoginUserInfo.Company}}</p></div>-->
               </div>
         <!--      <div class="Code"><img src="../../assets/Buttonicon/code.png"></div>-->
           </div>
           <div class="Hello"><img src="../../assets/Buttonicon/Hello_.png"></div>
           <div class="ButtonWrap">
               <i  @click="Exit"><img src="../../assets/Buttonicon/exit.png" alt="退出登录"></i>
               <router-link tag="i" :to="{name:'Setting'}"><img src="../../assets/Buttonicon/set.png" alt="资料设置"></router-link>
           </div>
        </div>
<!--        &lt;!&ndash; 消费充值入口 &ndash;&gt;
        <div class="PayforWrap flexa">
            <div class="flex Pay" @click="closeWindow">立即充值</div>
            <router-link tag="div" :to="{name:'Order'}" class="flex History">历史账单</router-link>
        </div>
        &lt;!&ndash; 钱包入口 &ndash;&gt;
        <div class="MyMoney flexa">
             <div class="IconWrap"><img src="../../assets/m_1.png"><p>我的钱包</p></div>
             <div class="Num"><p><span>我的余额 RMB </span><span> 5,0000</span></p></div>
        </div>-->
        <!-- 认证入口 -->
        <div class="RZWrap hidden" @click="OpenSenchaBox('authentication')">
            <img src="../../assets/Home/rz.jpg">
        </div>
        <div class="RZWrap" @click="OpenRz">
            <img src="../../assets/Home/rz.jpg">
        </div>
        <div class="CommonList" v-if="true">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>我的服务 <span></span></p></div>
            </div>
            <div class="ListWrap clearfix">
                <router-link
                        tag="div"
                        :to="{
                        name: 'Service',
                        params: { orderstate: item.服务状态, index: index + 1 }
                        }"
                        class="List"
                        v-for="(item, index) in servedata"
                        :key="index"
                >
                    <div class="ListTitle"><p>{{ item.服务状态 }}</p></div>
                    <div class="ListImg"><img  :src="item.src"></div>
                    <div class="ListNum"><p>{{ item.产品数量 }}</p></div>
                </router-link>
            </div>
        </div>
        <!-- 服务项目 -->
        <div class="CommonList" v-if="true">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>我的订单 <span></span></p></div>
            </div>
            <div class="ListWrap clearfix">
                <router-link tag="div" :to="{name:'Order',params: { orderstate: '', index: 0 } }" class="List">
                    <div class="ListTitle"><p>全部</p></div>
                    <div class="ListImg"><img src="../../assets/Buttonicon/s-1.png"></div>
                    <div class="ListNum"><p>{{ allnum }}</p></div>
                </router-link>
                <router-link tag="div" :to="{name:'Order',  params: { orderstate: '待支付', index: 1 } }" class="List">
                    <div class="ListTitle"><p>待支付</p></div>
                    <div class="ListImg"><img src="../../assets/Buttonicon/s-2.png"></div>
                    <div class="ListNum"><p>{{ num1 }}</p></div>
                </router-link>
                <router-link tag="div" :to="{name:'Order',params: { orderstate: '已支付', index: 2 } }" class="List">
                    <div class="ListTitle"><p>已支付</p></div>
                    <div class="ListImg"><img src="../../assets/Buttonicon/s-3.png"></div>
                    <div class="ListNum"><p>{{ num2 }}</p></div>
                </router-link>
                <router-link tag="div" :to="{name:'Order',params: { orderstate: '已取消', index: 3 } }" class="List">
                    <div class="ListTitle"><p>已取消</p></div>
                    <div class="ListImg"><img src="../../assets/Buttonicon/s-4.png"></div>
                    <div class="ListNum"><p>{{ num3 }}</p></div>
                </router-link>
            </div>
        </div>
        <div class="ListWrap1 flexa">
            <router-link tag="div" :to="{name:'Invoice'}"><img src="../../assets/Buttonicon/s-10.png"><p>我的发票</p></router-link>
            <div><img src="../../assets/Buttonicon/s-7.png"><p>关于我们</p></div>
            <router-link tag="div" :to="{name:'Setting'}"><img src="../../assets/Buttonicon/s-8.png"><p>我的设置</p></router-link>
        </div>
    </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import axios from 'axios';
  import Savemoney from '../../components/SaveMoney';
  // import axios from 'axios';
  export default {
    components: { Savemoney },
    inject: [
      'load'
    ],
    data() {
      return {
        /* 签发机关 */
        signorg: '',
        /* 出生日期 */
        birthday: '',
        /* 民族 */
        nation: '',
        /* 开始时间 */
        termstart: '',
        /* 性别 */
        sex: '',
        cardname: '',
        cardid: '',
        phone: '',
        term: '',
        address: '',
        carduppicfront: '',
        carduppicback: '',
        namerzstate: false,
        rzstate: false,
        zcdata: [],
        rzaddstate: true,
        servedata: [
          {
            服务状态: '创建',
            src: '',
            产品数量: '0'
          },
          {
            服务状态: '使用',
            src: '',
            产品数量: '0'
          },
          {
            服务状态: '超期',
            src: '',
            产品数量: '0'
          },
          {
            服务状态: '终止',
            src: '',
            产品数量: '0'
          }
        ],
        allnum: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        frontstate: false,
        backstate: false,
        allservenum: 0,
        zcemail: '',
        zcuser: '',
        yingyepic: '',
        zcphone: '',
        zccardid: '',
        zccn: '',
        zcname: '',
        zccode: '',
        MoneyOpenState: false
      };
    },
    async mounted() {
      console.log(this.LoginUserInfo);
      this.GetOrder();
      this.GetServe();
    },
    created () {
      this.CheckIsrz();
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo', 'currentSystem', 'Isrz'])
    },
    methods: {
      /* 获取是否认证 */
      CheckIsrz() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: `${this.$userMangerUrl}user/v1/isrealauth`,
          data: {
            goeasyid: this.LoginUserInfo.goeasyid
          }
        }).then(res => {
          this.load.hide();
          if (res.data.code === 0) {
            if (res.data.data === 1) {
              this.setIsrz(true);
            } else {
              this.setIsrz(false);
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message({
            type: 'error',
            message: error
          });
        });
      },
      /* 验证身份证有效期 */
      DateIsValidate(date) {
        let now = new Date().getYear();
        let today = new Date(now);
        let day = new Date(date);
        if (day < today) {
          this.$message({
            type: 'error',
            message: '您上传的身份证信息已过期，请更换证件后再试!'
          });
          return false;
        }
        return true;
      },
      /* 营业执照 */
      afterReadyingyepic(file) {
        this.load.show();
        this.yingyepic = file.content;
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/file/FileSystem/Upload',
          data: {
            userId: this.LoginUserInfo.userId,
            files: JSON.stringify([{ filename: 'yingyepic.JPG', content: file.content }])
          }
        }).then(res => {
          this.load.hide();
          if (res.data.code === 0) {
            this.yingyepic = res.data.data.GoeasyUploadUrlFileName;
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message({
            type: 'error',
            message: error
          });
        });
      },
      /* 获取上传的身份证照片信息 ---图片地址--- --- 图片正反面标识(1/2)--- */
      AfterCardLoad(url, cardtype) {
        // eslint-disable-next-line eqeqeq
        if (cardtype == '1') {
          this.frontstate = false;
          // eslint-disable-next-line eqeqeq
        } else if (cardtype == '2') {
          this.backstate = false;
        }
        this.$axios({
          method: 'POST',
          url: 'https://ocridcard.market.alicloudapi.com/idCardAuto',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Authorization: 'APPCODE d7a8f61041444803beecbbdb0d16a686'
          },
          transformRequest: [
            function (data) {
              let ret = '';
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  '=' +
                  encodeURIComponent(data[it]) +
                  '&';
              }
              return ret;
            }
          ],
          data: {
            image: url
          }
        }).then(result => {
          this.load.hide();
          console.log(result.data);
          // debugger;
          // Loading.hidden();
          if (result.data.code !== '1' && result.data.code !== '2') {
            this.$message.error('身份信息获取失败,请重新上传身份证,且保证图片完整,清晰!');
            return;
            // alert('身份信息获取失败,请重新上传身份证,且保证图片完整,清晰!');
          }
          // 身份证图片类型 1 正面， 2 背面
          // 返回类型不符，证明不对
          // eslint-disable-next-line eqeqeq
          if (result.data.code != cardtype) {
            console.log(result.data.code, cardtype);
            this.$message({
              type: 'error',
              // eslint-disable-next-line eqeqeq
              message: '身份信息获取失败,请重新上传身份证' + (cardtype == '1' ? '人像面' : '国徽面') + '照片,且保证图片完整,清晰!'
            });
            return;
          }
          // eslint-disable-next-line eqeqeq
          if (cardtype == '1') {
            this.cardname = result.data.result.name;
            this.cardid = result.data.result.code;
            this.address = result.data.result.address;
            this.birthday = result.data.result.birthday;
            this.nation = result.data.result.nation;
            this.sex = result.data.result.sex;
            this.frontstate = true;
            this.load.hide();
          } else {
            this.signorg = result.data.result.issue;
            this.termstart = result.data.result.issueDate;
            // 有效期
            if (result.data.result.expiryDate) {
              console.log(result.data.result.expiryDate);
              let newExpiryDate = result.data.result.expiryDate.substr(0, 4) + '/' + result.data.result.expiryDate.substr(4, 2) + '/' + result.data.result.expiryDate.substr(6, 2);
              console.log(newExpiryDate);
              this.DateIsValidate(newExpiryDate);
              this.term = newExpiryDate;
              this.load.hide();
              if (this.DateIsValidate(newExpiryDate)) {
                this.backstate = true;
              } else {
                this.load.hide();
                this.$message({
                  type: 'error',
                  message: '身份信息获取失败,请重新上传身份证国徽面照片,且保证图片完整,清晰!'
                });
              }
            } else {
              this.load.hide();
              this.$message({
                type: 'error',
                message: '身份信息获取失败,请重新上传身份证国徽面照片,且保证图片完整,清晰!'
              });
            }
          }
        }).catch(error => {
          this.load.hide();
          this.$toast.fail({
            message: error
          });
        });
      },
      /* 杨哥接收认证结果接口 */
      PostRzData_Yange() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://model.goeasy.cn:8201/user/v1/realauth',
          data: {
            goeasyid: this.LoginUserInfo.goeasyid,
            idnum: this.cardid,
            name: this.cardname,
            term: this.term,
            fronturl: this.carduppicfront,
            backurl: this.carduppicback,
            tel: this.phone,
            address: this.address,
            birthday: this.birthday,
            nation: this.nation,
            termstart: this.termstart,
            sex: this.sex,
            signorg: this.signorg,
            userId: this.LoginUserInfo.userId
          }
        }).then(res => {
          this.load.hide();
          console.log(res);
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '实名认证成功!'
            });
            this.CheckIsrz();
            this.namerzstate = false;
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message({
            type: 'error',
            message: error
          });
        });
      },
      /* 企业查重 */
      CheckComponey() {
        if (
          this.zcuser &&
          this.zcphone &&
          this.zccn &&
          this.zcname &&
          this.zccode &&
          this.zccardid &&
          this.yingyepic
        ) {
          this.load.show();
          this.$axios({
            method: 'POST',
            url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
            data: {
              commandId: 'WBA0007050',
              buttonText: 'Verify',
              userId: 'GoeasyUser' + this.LoginUserInfo.userId,
              headData: {
                企业名称: this.zcuser,
                证件号码: this.zccode
              }
            }
          }).then(res => {
            if (res.data.code === 0) {
              if (res.data.data.DETAIL.length > 0) {
                this.load.hide();
                this.$message.error('该企业名称或社会信用代码已注册认证，不允许重复注册！');
              } else {
                this.SubmitZcCheck();
              }
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
        } else {
          this.$message.error('请确认所有信息已填写完毕');
        }
      },
      /* 申请人证-实名认证 */
      PostRzData() {
        console.log(this.cardname, this.cardid, this.phone, this.carduppicfront, this.carduppicback, this.backstate, this.frontstate);
        if (!this.cardname) {
          this.$message({
            type: 'error',
            message: '请输入姓名!'
          });
        } else if (!this.cardid) {
          this.$message({
            type: 'error',
            message: '请输入身份证号!'
          });
        } else if (!this.phone) {
          this.$message({
            type: 'error',
            message: '请输入联系电话!'
          });
          // eslint-disable-next-line eqeqeq
        } else if (!this.carduppicfront || this.frontstate == false) {
          this.$message({
            type: 'error',
            message: '请确保上传身份证正面照片无误!'
          });
          // eslint-disable-next-line eqeqeq
        } else if (!this.carduppicback || this.backstate == false) {
          this.$message({
            type: 'error',
            message: '请确保上传身份证反面照片无误!'
          });
        } else {
          this.load.show();
          this.$axios({
            method: 'GET',
            url: 'https://idcardcert.market.alicloudapi.com/idCardCert',
            dataType: 'JSON',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Authorization: 'APPCODE d7a8f61041444803beecbbdb0d16a686'
            },
            params: {
              idCard: this.cardid,
              name: this.cardname
            }
          }).then(res => {
            this.load.hide();
            // eslint-disable-next-line eqeqeq
            if (res.data.status == '01') {
              console.log(res);
              this.PostRzData_Yange();
            }
          }).catch(error => {
            this.load.hide();
            this.$message({
              type: 'error',
              message: error
            });
          });
        }
      },
      /* 身份证正面 */
      afterReadCardFront(file) {
        this.load.show();
        this.carduppicfront = file.content;
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/file/FileSystem/Upload',
          data: {
            userId: this.LoginUserInfo.userId,
            files: JSON.stringify([{ filename: 'CardFrontPic.JPG', content: file.content }])
          }
        }).then(res => {
          if (res.data.code === 0) {
            this.carduppicfront = res.data.data.GoeasyUploadUrlFileName;
            this.AfterCardLoad(this.carduppicfront, 1);
          } else {
            this.load.hide();
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message({
            type: 'error',
            message: error
          });
        });
      },
      /* 身份证背面 */
      afterReadCardBack(file) {
        this.load.show();
        this.carduppicback = file.content;
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/file/FileSystem/Upload',
          data: {
            userId: this.LoginUserInfo.userId,
            files: JSON.stringify([{ filename: 'CardBackPic.JPG', content: file.content }])
          }
        }).then(res => {
          if (res.data.code === 0) {
            this.carduppicback = res.data.data.GoeasyUploadUrlFileName;
            this.AfterCardLoad(this.carduppicback, 2);
          } else {
            this.load.hide();
            this.$message({
              type: 'error',
              message: res.data.msg
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message({
            type: 'error',
            message: error
          });
        });
      },
      ToNameRz() {
        this.namerzstate = true;
      },
      CloseNameRz() {
        this.namerzstate = false;
      },
      SubmitZc() {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007040',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            headData: {
              用户ID: this.LoginUserInfo.goeasyid,
              企业名称: this.zcuser,
              证件号码: this.zccode,
              法人姓名: this.zcname,
              联系人: this.zccn,
              联系方式: this.zcphone,
              法人身份证号码: this.zccardid,
              营业执照图: this.yingyepic
            },
            saveGridData: 1
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.$confirm('企业注册成功！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
              }).then(() => {
                this.zcuser = '';
                this.zccode = '';
                this.zcname = '';
                this.yingyepic = '';
                this.zcphone = '';
                this.zccn = '';
                this.zccardid = '';
                this.rzaddstate = true;
                this.GetZcCompneyList();
              }).catch(() => {
                this.zcuser = '';
                this.zccode = '';
                this.zcemail = '';
                this.zcname = '';
                this.zccardid = '';
                this.yingyepic = '';
                this.GetZcCompneyList();
              });
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
      },
      SubmitZcCheck() {
        this.$axios({
          method: 'POST',
          url: 'https://axq.goeasy.cn:8020/anxin/EnterpriseCert4',
          data: {
            OrganizationName: this.zcuser,
            OrgIdentificationNumber: this.zccode,
            PersonName: this.zcname,
            IdentificationNumber: this.zccardid
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.data === 1) {
              this.SubmitZc();
            } else {
              this.load.hide();
              // eslint-disable-next-line eqeqeq
              if (res.data.msg == '不匹配[验证结果不匹配：|查询成功无结果|]') {
                this.$message.error('[企业名称]或[社会信用代码]录入错误，请检查!');
                // eslint-disable-next-line eqeqeq
              } else if (res.data.msg == '参数校验失败[企业识别号类型与识别号不符，请检查！]') {
                this.$message.error('[社会信用代码]录入错误，请检查！');
                // eslint-disable-next-line eqeqeq
              } else if (res.data.msg == '不匹配[验证结果不匹配：|法人姓名不匹配|]') {
                this.$message.error('[法人姓名]录入错误，请检查！');
                // eslint-disable-next-line eqeqeq
              } else if (res.data.msg == '不匹配[验证结果不匹配：|法人证件号码不匹配|]') {
                this.$message.error('[法人身份证号]不匹配，请检查！');
                // eslint-disable-next-line eqeqeq
              } else if (res.data.msg == '参数校验失败[身份证号校验失败，请检查！]') {
                this.$message.error('[法人身份证号]录入错误，请检查!');
                // eslint-disable-next-line eqeqeq
              } else if (res.data.msg == '不匹配[验证结果不匹配：|法人证件号码不匹配||法人姓名不匹配|]') {
                this.$message.error('[法人身份证号]或[法人姓名]录入错误，请检查!');
              } else {
                this.$message.error(res.data.msg);
              }
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
      },
      /* 获取注册企业列表 */
      GetZcCompneyList() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007043',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.zcdata = res.data.data.DETAIL;
              this.rzstate = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
          });
      },
      Add() {
        console.log('新增');
        this.rzaddstate = false;
      },
      OpenRz() {
        if (this.Isrz) {
          this.GetZcCompneyList();
        } else {
          this.$confirm('您当前没有实名认证,请实名认证后再进行注册企业操作!', '提示', {
            confirmButtonText: '马上去',
            cancelButtonText: '稍后去',
            type: 'warning'
          }).then(() => {
            this.ToNameRz();
          }).catch(() => {
            console.log('取消操作');
          });
        }
      },
      Closerz() {
        if (!this.rzaddstate) {
          this.rzaddstate = true;
        } else {
          this.zcuser = '';
          this.zccode = '';
          this.zcemail = '';
          this.zcname = '';
          this.rzstate = false;
        }
      },
      /* 服务基本信息 */
      GetServe() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007016',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res.data.data.DETAIL);
              for (let i in res.data.data.DETAIL) {
                this.allservenum = this.$utils.accAdd(
                  this.allservenum,
                  res.data.data.DETAIL[i].产品数量
                );
                if (res.data.data.DETAIL[i].服务状态 === '创建') {
                  this.servedata[0].src = require('../../assets/Buttonicon/s5.png');
                  this.servedata[0].产品数量 = res.data.data.DETAIL[i].产品数量;
                  console.log(res.data.data.DETAIL[i].产品数量);
                } else if (res.data.data.DETAIL[i].服务状态 === '超期') {
                  this.servedata[2].src = require('../../assets/Buttonicon/s-5.png');
                  this.servedata[2].产品数量 = res.data.data.DETAIL[i].产品数量;
                  console.log(res.data.data.DETAIL[i].产品数量);
                } else if (res.data.data.DETAIL[i].服务状态 === '使用') {
                  this.servedata[1].src = require('../../assets/Buttonicon/s-6.png');
                  this.servedata[1].产品数量 = res.data.data.DETAIL[i].产品数量;
                  console.log(res.data.data.DETAIL[i].产品数量);
                } else {
                  this.servedata[3].src = require('../../assets/Buttonicon/s-4.png');
                  this.servedata[3].产品数量 = res.data.data.DETAIL[i].产品数量;
                  console.log(res.data.data.DETAIL[i].产品数量);
                }
              }
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      GetOrder() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007045',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res.data.data.DETAIL);
              /**/
              for (let i in res.data.data.DETAIL) {
                this.allnum = this.$utils.accAdd(
                  this.allnum,
                  res.data.data.DETAIL[i].订单数量
                );
                if (res.data.data.DETAIL[i].订单状态 === '待支付') {
                  this.num1 = res.data.data.DETAIL[i].订单数量;
                } else if (res.data.data.DETAIL[i].订单状态 === '已支付') {
                  this.num2 = res.data.data.DETAIL[i].订单数量;
                } else {
                  this.num3 = res.data.data.DETAIL[i].订单数量;
                }
              }
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取钱包余额 */
      closeWindow() {
        this.MoneyOpenState = !this.MoneyOpenState;
      },
      OpenSenchaBox(type) {
        // debugger;
        if (type === 'model') {
          this.$store.dispatch('setplatformname', 'PaaS平台');
        } else if (type === 'authentication' || type === 'normal' || type === 'manager' || type === 'test') {
          this.$store.dispatch('setplatformname', 'SaaS平台');
        }
        if (this.LoginUserInfo.userId) {
          console.log(123);
          if (type === 'authentication' || type === 'normal') { // 认证 运营
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'model' || type === 'manager' || type === 'test') { // 建模 配置
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/getnewtoken', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
                identity: type
              }
            }).then((res) => {
              if (res.data.code === 0) {
                this.$store.dispatch('togglesenchabox', true);
                window.GEVAR.MainController.addInitPage({ user: [res.data.data.user], platform: type, data: res.data.data, code: this.currentSystem.code, name: this.currentSystem.name });
              }
            });
          }
        } else {
          this.$emit('OpenLoginBox');
        }
      },
      Return() {
        this.$router.back();
      },
      Exit() {
        this.$confirm('是否确认退出当前账号?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loginOut();
          this.setCurrentSystem({ code: '', name: '' });
          this.$router.push({ path: '/' });
        }).catch(() => {
        });
      },
      ...mapActions(['loginOut', 'setCurrentSystem', 'setIsrz'])
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
.PersonCenter{
    width: 100%;
    .AddInvoice{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5;
      .EditList{
        width: 85%;
        margin: 0.05rem auto;
        font-size: $TextSize;
        input{
          margin-left: 0.05rem;
          font-size: $AdditionTextSize;
          background-color: #eee;
          width: 1rem;
          padding: 0.035rem;
          border-radius: 0.02rem;
        }
      }
        .PicUp{
        width:  85%;
        margin: 0.04rem auto;
        .HeaderPic{
            width: 1.3rem;
            height: 0.8rem;
            border-radius: 0.03rem;
            position: relative;
            background-color: #a0bef7;
            .Upload{
              width: 100%;
              height: 100%;
              opacity: 0;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 3;
             .van-uploader{
                display: flex;
               -webkit-justify-content: center;
               -webkit-align-items: center;
              }
            }
            .headpic{
              width: 100%;
              height: 100%;
              border-radius: 0.03rem;
              object-fit: cover;
            }
            i{
              width: 100%;
              height: 100%;
              border-radius: 0.03rem;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 2;
              img{
                width: 0.2rem;
              }
            }
          }
        p{
          font-size: $TextSize;
          color: #fff;
        }
      }
        .InputWrap {
            width: 86%;
            margin: 0.1rem auto 0;
           div{
                    width: 100%;
                    margin-bottom: 0.1rem;
                    span {
                        font-size: $TextSize;
                        color: #414141;
                        width: 0.4rem;
                      text-align: left;
                    }
                    input {
                      margin-left: 0.05rem;
                      font-size: $AdditionTextSize;
                      background-color: #eee;
                      width: 1rem;
                      padding: 0.035rem;
                      border-radius: 0.02rem;
                    }
                    input::placeholder{
                        font-size: $TextSize;
                    }
                }
                .tip {
                    margin-bottom: 0.08rem;
                    span {
                        font-size: $SmallTextSize;
                        color: rgba(65, 65, 65, 0.8);
                    }
                }
        }
        .DeveloperWrap {
            width: 100%;
            height: calc(100% - 0.7rem);
            overflow: scroll;
            overflow-scrolling: touch;
            margin-top: 0.05rem;
            &::-webkit-scrollbar {
                display: none;
            }
            ul {
                width: 100%;
                padding-bottom: 0.2rem;
                li{
                    width: 86%;
                    margin: 0.05rem auto;
                    background: linear-gradient(to Right, #7a7a7a, #484848);
                    overflow: auto;
                    padding: 0.08rem 0;
                    border-radius: 0.05rem;
                    p{
                        color: #fff;
                        margin-left: 0.1rem;
                    }
                    p:first-child{
                        font-size: $TitleSize;
                        margin-top: 0.02rem;
                    }
                    p:nth-child(2){
                        font-size: $TextSize;
                        margin: 0.1rem 0 0.02rem 0.1rem;
                    }
                    p:last-child{
                        font-size: $SmallTitleSize;
                    }
                }
            }
        }
        .AddWrap{
            width: 30%;
            height: calc(100% - 1rem);
            background-color: #fff;
            border-radius: 0.1rem;
            header {
                width: 88%;
                height: 0.2rem;
                margin: 0 auto;
                padding-top: 0.1rem;
                position: relative;
                i {
                    width: 0.1rem;
                    cursor: pointer;
                    img {
                        width: 100%;
                    }
                }
                p {
                    font-size: $SmallTitleSize;
                    color: #666666;
                    position: absolute;
                    right: 0;
                    font-weight: bold;
                }
            }
        }
    }
    .CommonList{
        width: 100%;
        .ListWrap{
            width: 90%;
            margin: 0.1rem auto;
            .List{
                width: 49%;
                height: 0.5rem;
                border: 1px solid #fff;
                border-radius: 0.05rem;
                margin-bottom: 2%;
                float: left;
                position: relative;
                cursor: pointer;
                .ListTitle{
                    position: absolute;
                    left: 0.07rem;
                    top: 0.07rem;
                    p{
                        font-size: $TextSize;
                        font-weight: bold;
                        color: #fff;
                    }
                }
                .ListImg{
                    position: absolute;
                    left: 0.08rem;
                    bottom: 0.08rem;
                    height: 0.2rem;
                    img{
                        height: 100%;
                    }
                }
                .ListNum{
                    position: absolute;
                    right: 0.1rem;
                    bottom: 0.12rem;
                    p{
                        font-size: $NumTitleSize;
                        color: #fff;
                        font-weight: bold;
                    }
                }
            }
            .List:nth-child(odd){
                margin-right: 1.3%;
            }
        }
    }
    .ListWrap1{
        width: 90%;
        margin: 0.05rem auto 0;
        div:nth-child(2){
            margin: 0 2%;
            background-color: #358747;
        }
        div{
            width: 32%;
            height: 1.05rem;
            cursor: pointer;
            background-color: #d3992e;
            border-radius: 0.1rem;
            img{
                height: 0.3rem;
                margin:0.3rem auto 0.08rem;
            }
            p{
                font-size: $SmallTitleSize;
                text-align: center;
                font-weight: bold;
                color: #fff;
            }
        }
        div:last-child{
            margin-right: 0;
            background-color: #3f505f;
        }
    }
    .MyMoney{
        width: 90%;
        margin: 0 auto;
        height: 0.38rem;
        border-radius: 0 0 0.08rem 0.08rem;
        position: relative;
        background:linear-gradient(to Right, #9b573a,#c19160);
        .Num{
            position: absolute;
            right: 0.1rem;
            bottom: 0.06rem;
            p{
                span{
                    color: #fff;
                }
                span:first-child{
                    font-size: $AdditionTextSize;
                }
                span:last-child{
                    font-size: $NumTitleSize;
                    font-weight: bold;
                }
            }
        }
        .IconWrap{
            width: 0.6rem;
            img{
                width: 0.2rem;
                margin: 0 auto;
            }
            p{
                font-size: $TextSize;
                color: #fff;
                text-align: center;
                font-weight: bold;
                margin-top: 0.03rem;
            }
        }
    }
    .PayforWrap{
        width:90%;
        margin: 0 auto;
        height: 0.2rem;
        background: linear-gradient(to Right, #261c1c,#303030);
        position: relative;
        .Pay,.History{
            width: 0.32rem;
            height: 0.11rem;
            border-radius: 0.3rem;
            font-size: $TextSize;
            color: #fff;
            position: absolute;
            border: 1px solid #fff;
            cursor: pointer;
        }
        .Pay{
            right: 0.38rem;
        }
        .History{
            right: 0.02rem;
        }
    }
    .PersonCard{
        width: 90%;
        height: 1.1rem;
        border-radius: 0.08rem;
        margin: 0.1rem auto 0;
        background-image: url("../../assets/BG/person.jpg");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .ButtonWrap{
            position: absolute;
            right: 0.1rem;
            top: 0.1rem;
            i{
                width: 0.12rem;
                margin-bottom: 0.07rem;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
        }
        .Hello{
            position: absolute;
            width: 0.7rem;
            right: 0.13rem;
            bottom: 0.1rem;
            img{
                width: 100%;
            }
        }
        .Left{
            width: 1.6rem;
            height: 0.6rem;
            padding: 0.1rem 0 0 0.1rem;
            .Head{
                width: 0.4rem;
                height: 0.4rem;
                border-radius: 0.05rem;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 0.05rem;
                }
            }
            .InputWrap{
                width: 0.9rem;
                margin: 0 0.05rem 0 0.1rem;
                .Text{
                    width: 0.9rem;
                    height: 0.13rem;
                    border-radius: 0.15rem;
                    background-color:#0066cc;
                    margin-bottom: 0.05rem;
                    img{
                        width: 0.06rem;
                        margin: 0 0.05rem;
                    }
                    p{
                        font-size: $TextSize;
                        color: #fff;
                    }
                }
            }
            .Code{
                width: 0.12rem;
                height: 0.12rem;
                cursor: pointer;
                padding: 0.015rem 0.04rem 0 0;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .RZWrap{
        width: 90%;
        margin: 0.1rem auto;
        cursor: pointer;
        img{
            width: 100%;
            border-radius: 0.08rem;
        }
    }
    .LineCut{
        width: 90%;
        margin: 0.05rem auto 0.05rem;
        border-bottom: 2px solid #fff;
        .Return{
            cursor: pointer;
            p{
                font-size: $AdditionTextSize;
                color: #fff;
            }
            img{
                width: 0.05rem;
                margin-left: 0.02rem;
            }
        }
        .NewsTitle{
            p{
                font-size: $TitleSize;
                color: #fff;
                padding-bottom: 0.045rem;
                span{
                    opacity: 0.6;
                    font-weight: normal;
                }
            }
        }
    }
}
</style>
